import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { CartService } from '../../../core/services/cart.service';
import { CategoryService } from '../../../core/services/category.service';
import { LanguageService, LangCode } from '../../../core/services/language.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgIf, NgFor],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  cart = inject(CartService);
  cats = inject(CategoryService).list();
  langSvc = inject(LanguageService); // <- servicio central

  // === DICCIONARIO SOLO DEL HEADER ===
  private dict: Record<LangCode, any> = {
    en: {
      nav:{ home:'Home', products:'Products', software:'Software', about:'About us', contact:'Contact', allCats:'View all categories' },
      software:{ lis:'Clinical LIS', bb:'Blood Bank', vet:'Vet LIS', bloodBank:'Blood Bank' },
      aria:{ changeLang:'Change language', cart:'Cart' }
    },
    es: {
      nav:{ home:'Inicio', products:'Productos', software:'Software', about:'Nosotros', contact:'Contacto', allCats:'Ver todas las categorías' },
      software:{ lis:'LIS Clínico', bb:'Banco de Sangre', vet:'Vet LIS', bloodBank:'Banco de Sangre' },
      aria:{ changeLang:'Cambiar idioma', cart:'Carrito' }
    },
    pt: {
      nav:{ home:'Início', products:'Produtos', software:'Software', about:'Sobre nós', contact:'Contato', allCats:'Ver todas as categorias' },
      software:{ lis:'LIS Clínico', bb:'Banco de Sangue', vet:'Vet LIS', bloodBank:'Banco de Sangue' },
      aria:{ changeLang:'Mudar idioma', cart:'Carrinho' }
    },
    ko: {
      nav:{ home:'홈', products:'제품', software:'소프트웨어', about:'회사소개', contact:'문의', allCats:'모든 카테고리 보기' },
      software:{ lis:'임상 LIS', bb:'혈액은행', vet:'수의학 LIS', bloodBank:'혈액은행' },
      aria:{ changeLang:'언어 변경', cart:'장바구니' }
    }
  };

  // ===== Helpers para usar en el template =====
  t(path: string): string {
    const obj = this.dict[this.langSvc.lang];
    return path.split('.').reduce<any>((acc, key) => acc?.[key], obj) ?? path;
  }

  get langs() { return this.langSvc.langs; }              // lista de idiomas (del servicio)
  get currentFlag() { return this.langSvc.getFlag(); }    // bandera actual
  setLang(code: LangCode) { this.langSvc.setLang(code); } // cambia idioma (y persiste)
}
